
import AuthFacade from "@/infraestructure/auth/auth_facade";
import { MedicalBackground } from '@/domain/entities/MedicalBackground';
import { MedicalAnswerType } from '@/domain/entities/MedicalQuestion';
import { PatientRepository } from '@/infraestructure/patient/PatientRepository';
import { pprint } from '@/helpers/pprint'
import {
	defineComponent,
	onMounted,
	// reactive,
	ref,
	inject,
} from "vue";

export default defineComponent({
	name: 'health-form',
	props: {
		modelValue: Object
	},
	async setup(_, {emit}) {
		const hf = ref<HTMLElement | null>(null)
		onMounted(() => {
			hf.value?.addEventListener('input', (ev) => {
				pprint('input ev', ev)
				emit('update:modelValue', hb.value)
			})
		})

		let patientRespository = inject(PatientRepository.key) as PatientRepository
		let authFacade = inject(AuthFacade.key) as AuthFacade
	
		const hb = ref<MedicalBackground[] | null>(null)
		hb.value = await patientRespository.fetchAndFormatHealthInformation(authFacade.user?.uid || '')
		pprint('hb', hb.value)

		return {
			hb, MedicalAnswerType, hf
		}
	}
})
